const MAX_RECENT_COLORS = 110;
const STORAGE_KEY = 'recentColors_user';

// Get recent colors for the current user
export const getRecentColors = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Failed to load recent colors from localStorage:', error);
    return [];
  }
};

// Add a color to recent colors list
export const addRecentColor = (color) => {
  if (!color) return;
  
  try {
    const recentColors = getRecentColors();
    
    // Remove the color if it already exists (to move it to the front)
    const filteredColors = recentColors.filter(c => c !== color);
    
    // Add the new color to the beginning
    const updatedColors = [color, ...filteredColors];
    
    // Keep only the most recent MAX_RECENT_COLORS
    const trimmedColors = updatedColors.slice(0, MAX_RECENT_COLORS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedColors));
    
    // Return the updated list for immediate use
    return trimmedColors;
  } catch (error) {
    console.warn('Failed to save recent color to localStorage:', error);
  }
};

// Clear all recent colors for the user
export const clearRecentColors = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear recent colors from localStorage:', error);
  }
}; 